<template>
  <nav :class="'navbar navbar-default header-navbar' + (tabGrid ? ' header-navbar-pills' : '')" style="min-height: initial !important" @click="toggleColumn()" ref="tabnav">
    <div :class="'navbar-wrap' + (isLayoutEditMode ? '' : ' column-tabs-grid')">
      <draggable v-if="isLayoutEditMode" v-model="myComponents" group="columnheader" tag="ul" draggable=".component" :delay="100" :delayOnTouchOnly="true" :componentData="{ attrs: { class: 'nav navbar-nav' }}" v-on:change="componentOrderChanged">
        <template v-for="component in myComponents">
          <span v-if="component.id === 'menu' && showHamburger" class="navbar-menu"><a v-on:click.stop="setMenuComponent" href="javascript:;" class="fa fa-fw fa-bars"></a></span>
          <li v-else-if="parseInt(component.id)" :class="'component ' + (activeComponent.id == component.id ? 'active' : '')"><a href="javascript:;" v-on:click.stop="setActiveComponent(component)">{{ component.name }}<i v-if="showEditComponentButton && isComponentEditable(component)" v-on:click.stop="editComponent(component)" class="fa fa-fw fa-pencil" style="padding-left: 5px"></i></a></li>
          <li v-else-if="component.id === 'add' && showAddComponentButton"><a href="javascript:;" v-on:click.stop="addComponent"><i class="fa fa-fw fa-plus"></i></a></li>
        </template>
      </draggable>
      <template v-else>
        <!-- Normal mode (JDEV-3207): a grid of hamburger | tab strip (minmax(0, 1fr)) | header-right. The strip
             is one row; tabs that do not fit go to the "Lisää (n)" menu at its right edge. -->
        <span class="navbar-menu" v-if="showHamburger"><a v-on:click.stop="setMenuComponent" href="javascript:;" class="fa fa-fw fa-bars" :title="_('Menu')" :aria-label="_('Menu')"></a></span>
        <ColumnTabs
          :tabs="columnTabs"
          :selected-id="selectedTabId"
          :panel-id="panelId"
          :label="_('Tabs')"
          :show-add="!!showAddComponentButton"
          :add-label="_('Add component')"
          :layout-key="tabsLayoutKey"
          :grid="tabGrid"
          v-on:select="selectTab"
          v-on:add="addComponent"
        >
          <template #tab-extra="{ tab }">
            <span v-if="tab.component.type === 'Receipt' && numBasketItems" class="counter">{{ numBasketItems }}</span>
          </template>
          <template #tab-actions="{ tab, tabindex }">
            <button v-if="tab.component.type === 'Receipt' && posDeliveryAvailable" class="pos-delivery-icon column-tab-action" type="button" :tabindex="tabindex" :title="_('Delivery')" :aria-label="_('Delivery')" :aria-pressed="posDeliveryActive ? 'true' : 'false'" v-on:click.stop="togglePosDelivery">
              <i :class="'fa fa-fw fa-shopping-basket ' + (posDeliveryActive ? 'text-primary' : 'text-muted')" aria-hidden="true"></i>
            </button>
            <button v-if="!tab.floating && showEditComponentButton && isComponentEditable(tab.component)" class="column-tab-action column-tab-edit" type="button" :tabindex="tabindex" :title="_('Edit')" :aria-label="_('Edit')" v-on:click.stop="editComponent(tab.component)">
              <i class="fa fa-fw fa-pencil" aria-hidden="true"></i>
            </button>
            <button v-if="!tab.floating && isCloseButtonVisible(tab.component)" class="column-tab-action column-tab-close" type="button" :tabindex="tabindex" :title="_('Close')" :aria-label="_('Close')" v-on:click.stop="closeTab(tab.component)">
              <i class="fa fa-fw fa-close" aria-hidden="true"></i>
            </button>
          </template>
        </ColumnTabs>
      </template>
      <div class="header-right">
        <select class="form-control hidden-md hidden-lg select-version-xs" v-model="selectedVersion" v-if="showLanguageSelector" v-on:click.stop="preventColumnChange()">
          <option v-for="ver in versions" :value="ver">{{ getShortVersionName(ver) }}</option>
        </select>
        <select class="form-control hidden-sm hidden-xs select-version" v-model="selectedVersion" v-if="showLanguageSelector && (columns && columnIndex === columns.length - 1)">
          <option v-for="ver in versions" :value="ver">{{ getVersionName(ver) }}</option>
        </select>
        <div :class="'status-indicator ' + (hasDisconnection ? 'offline' : 'online') + (!(columns && columnIndex === columns.length - 1) ? ' hidden-md hidden-lg' : '')" v-on:click.stop="showConnectionStatus()">
          <i :class="'fa fa-fw ' + statusIconClass" :title="statusText"></i>
        </div>
        <div :class="'user-profile clickable' + (!(columns && columnIndex === columns.length - 1) ? ' hidden-md hidden-lg' : '')" v-on:click.stop="toggleRightNavi('user')">
          <span class="user-profile-image" :data-initials="initials"><img v-if="profileImageUrl" /></span>
        </div>
        <div :class="'settings clickable' + (!(columns && columnIndex === columns.length - 1) ? ' hidden-md hidden-lg' : '')" v-on:click.stop="toggleRightNavi('settings')">
          <i class="fa fa-fw fa-cog"></i>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>

import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import componenttypes from '~/lib/componenttypes'
import constants from '~/lib/constants'
import modals from '~/lib/modals'
import permissions from '~/lib/permissions'
import numbasketitems from '~/lib/numbasketitems'
import { ModalComponentDetails, ComponentEditor, ComponentSelector } from '#components'
import ColumnTabs from '~/components/ColumnTabs.vue'
import debounce from 'lodash/debounce'

const TAB_GRID_QUERY = '(min-width: 768px)'


export default {
  components: { ColumnTabs },
  data () {
    return {
      myComponents: [],
      localVersion: null,
      // id of the column root (the tab panel, see lib/components.js); the tabs point at it with aria-controls
      panelId: '',
      hasSocketDisconnection: false,
      profileImageUrl: false,
      tsInterval: null,
      currTs: Math.floor(Date.now() / 1000),
      // Viewport at least 768px wide: the "Column tabs" button grid (JDEV-3370) applies; below it, the one-row strip.
      tabGridWide: typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(TAB_GRID_QUERY).matches,
      tabGridMql: null,
      heartbeatOffset: 15 // Since the backend sends heartbeats at this.$config.heartbeat, we need a bit of time to allow the message to go through before we show a disconnection
    }
  },
  mixins: [componenttypes, constants, modals, permissions, numbasketitems],
  props: ['activeLayout', 'components', 'activeComponent', 'columns', 'columnIndex', 'floatingcolumn'],
  computed: {
    ...mapGetters(['allSettings', 'locale', 'shopId', 'baseDomain', 'editMode', 'userData', 'apiKey', 'version', 'unsavedChanges', 'posDeliveryActive', 'posDeliveryAvailable', 'heartbeatTs', 'columnTabsMode']),
    componentOptions () {
      return this.componentTypes.map(c => { return { value: c.type, name: c.name, desc: c.type }}).sort((a, b) => a.name > b.name ? 1 : -1)
    },
    hasDisconnection: {
      get () {
        return this.hasAmqpDisconnection || this.hasSocketDisconnection
      }, 
      set (value) {
        this.hasSocketDisconnection = value
      }
    },
    hasAmqpDisconnection () {
      const config = useRuntimeConfig().public
      if (config && config.heartbeat) {
        if (this.heartbeatTs < this.currTs - config.heartbeat - this.heartbeatOffset) { 
          return true
        }
      }
      return false
    },
    settings () {
      return this.shopSettings(this.shopId)
    },
    sideMenuOpen() {
      return this.$store.state.sideMenuOpen
    },
    isLastColumn () {
      if (!this.columns) return false
      return this.columnIndex === this.columns.length - 1
    },
    showHamburger () {
      //return this.columnIndex === 0 && this.canShowMenu
      return this.columnIndex === 0
    },
    statusIconClass () {
      if (this.hasDisconnection) {
        return 'fa-circle-o-notch fa-spin'
      }
      return 'fa-check'
    },
    statusText () {
      if (this.hasDisconnection) {
        return this._('Reconnecting to server...')
      }
      return this._('Connected to server.')
    },
    initials () {
      if (!this.userData) {
        return '-'
      }
      const name = this.userData.name.trim()
      let str = name.charAt(0)
      if(name.includes(' ')) {
        str = str + name.charAt(name.lastIndexOf(' ') + 1)
      }
      return str
    },
    showLanguageSelector () {
      if(this.floatingcolumn) {
        return true
      }
      if (!this.columns || this.showEditLayoutButton) {
        return false
      }
      //return this.columnIndex === [...new Set(this.activeLayout.ownComponent_layout.map(c => c.column))].length - 1
      // return this.columnIndex === this.columns.length - 1
      return true;
    },
    customComponentEditors () {
      return [
        'Agenda',
        'ButtonMap',
        'ClientReceipt',
        'Dashboard',
        'IFrame',
        'GasPump',
        'MovieList',
        'ProductList',
        'CategoryList',
        'ProductReservationSchedule',
        'ResourceList',
        'ResourceReservationSchedule',
        'Receipt',
        'ReportList',
        'Showtimes',
        'TicketActivityList',
        'Workflow'
      ]
    },
    myColumns () {
      return this.activeLayout && this.activeLayout.data ? JSON.parse(this.activeLayout.data).columns : []
    },
    isDynamicColumn () {
      return this.components && this.components.find(c => !!c.link_id) ? false : true
    },
    versions () {
      return this.settings && this.settings.versions ? this.settings.versions.split(';') : []
    },
    selectedVersion: {
      get () {
        return this.localVersion ? this.localVersion : this.version
      },
      set (newValue) {
        this.localVersion = newValue
        this.tryToSetVersion(newValue, this.version)
      }
    },
    isLayoutEditMode () {
      return !!this.showEditLayoutButton && !this.isDynamicColumn
    },
    // The tabs of the normal-mode strip (ColumnTabs). The floating column (floating Receipt) has no components
    // and shows its active component as its only tab, as before.
    columnTabs () {
      const tabs = (this.components || []).map(component => ({ id: String(component.id), label: component.name, component }))
      if (this.floatingcolumn && this.activeComponent && !tabs.some(t => t.id === String(this.activeComponent.id))) {
        tabs.push({ id: String(this.activeComponent.id), label: this.activeComponent.name, component: this.activeComponent, floating: true })
      }
      return tabs
    },
    selectedTabId () {
      return this.activeComponent && this.activeComponent.id != null ? String(this.activeComponent.id) : null
    },
    // The user interface's "Column tabs" setting (JDEV-3370): "grid" / "gridfixed" from 768px up, else null (one
    // row). Layout edit mode keeps its draggable list.
    tabGrid () {
      const mode = this.columnTabsMode
      return this.tabGridWide && !this.isLayoutEditMode && (mode === 'grid' || mode === 'gridfixed') ? mode : null
    },
    // Things that change a tab's width without changing its label: ColumnTabs re-fits the row when this changes.
    tabsLayoutKey () {
      return [this.numBasketItems, this.posDeliveryAvailable, this.posDeliveryActive, this.showEditComponentButton, this.showAddComponentButton].join('|')
    },
    activeComponentTrail () {
      if (this.activeComponent && this.activeComponent.initData && this.activeComponent.initData.trail) {
        return [...this.activeComponent.initData.trail, this.activeComponent]
      }
      return [this.activeComponent]
    }
  },
  methods: {
    onTabGridMedia (e) {
      this.tabGridWide = e.matches
    },
    ...mapActions([
      'setUnsavedChanges',
      'setVersion',
      'setPosDeliveryActive'
    ]),
    togglePosDelivery() {
      this.setPosDeliveryActive(!this.posDeliveryActive)
    },
    showConnectionStatus() {
      if (this.hasDisconnection) {
        this.$toast.error(this.statusText + '<br /><br /><a class="btn btn-default btn-xs" href="javascript:location.reload(true)">' + this._('Reload') + '</a>', 
        { 
          autoClose: 8000, 
          dangerouslyHTMLString: true
        })
      } else {
        this.$toast(this.statusText)
      }
    },
    toggleRightNavi(target = false) {
      this.EventBus.$emit('toggleRightNavi', {target: target})
    },
    async tryToSetVersion (version, oldVersion) {
      // This localVersion shit is needed because Vue doesn't seem to like that our setter actually doesn't set the value directly
      try {
        await this.checkUnsavedChanges()
      } catch(e) {
        setTimeout(() => {
          this.localVersion = oldVersion
          this.setVersion(oldVersion)
        }, 100)
        return
      }
      this.localVersion = version
      this.setVersion(version)
    },
    checkUnsavedChanges () {
      return new Promise((resolve, reject) => {
        if (!this.unsavedChanges) {
          resolve()
          return
        }
        this.showDialog({
          title: this._('You have unsaved changes. If you continue, they will be lost.'),
          buttons: [
            {
              title: this._('Cancel'),
              icon: 'check',
              handler: reject
            },
            {
              title: this._('Continue anyway'),
              class: 'danger',
              icon: 'trash',
              handler: () => {
                this.setUnsavedChanges(null)
                resolve()
              }
            }, 
          ],
          clickToClose: false
        })
      })
    },
    setActiveComponent (component) {
      this.$emit('setActiveComponent', component)
    },
    selectTab (id) {
      const component = (this.components || []).find(c => String(c.id) === id)
      if (component) {
        this.setActiveComponent(component)
      }
    },
    toggleColumn () {
      if(!this.floatingcolumn) {
        this.EventBus.$emit('toggleColumn', {
          column: this.columns[this.columnIndex]
        })
      }
    },
    preventColumnChange() {
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.locale] || {}
    },
    isCloseButtonVisible (component) {
      if (component.dynamic) {
        return true
      }
      if (this.activeComponent && this.activeComponent.id === component.id && this.columns && this.columns[this.columnIndex] && this.columns[this.columnIndex].identifier === 'details') {
        return true
      }
      /*
      // This would only allow closing of the extra details column tabs, such as when opening an invoice from order and so on
      if (this.activeComponent && this.activeComponent.id === component.id && component.initData && component.initData.trail) {
        return true
      }
      */
      return false
    },
    closeTab (component) {
      if (component.dynamic) {
        this.EventBus.$emit('hideComponent', component)
      } else {
        this.EventBus.$emit('hideDetailsColumn', {
          shopId: this.shopId,
          data: {
            trail: this.activeComponentTrail
          }
        })
      }
    },
    setMenuComponent () {
      this.EventBus.$emit('toggleMenu')
      
      /*
      this.$emit('setActiveComponent', {
        id: 0,
        name: 'Menu',
        type: 'Menu',
        data: ''
      })
      */
    },
    async componentOrderChanged (event) {
      // Enable re-ordering column components within the column and to/from other columns
      // This is a bit more involved than layoutOrderChanged since all the components live in the same list, with the "column" field separating them to each column
      // We can ignore "removed" callbacks since we always get an "added" property when moving between columns
      if (event.removed) {
        return
      }
      const col = this.myColumns[this.columnIndex].identifier
      const components = []
      const doneIds = {}
      const index = {}
      let addedId = null
      if (event.added) {
        addedId = event.added.element.link_id
      }
      for (let i = 0; i < this.myComponents.length; i++) {
        const mc = this.myComponents[i]
        if (!parseInt(mc.id)) {
          continue
        }
        const ac = this.activeLayout.ownComponent_layout.find(c => c.id === mc.link_id)
        if (ac && (ac.column === col || ac.id === addedId)) {
          if (!index[col]) {
            index[col] = 1
          }
          components.push({ component_id: mc.id, column: col, index: index[col]++})
          doneIds[ac.id] = true
        }
        // console.log(mc.id, mc.name, ac)
      }
      for (let i = 0; i < this.activeLayout.ownComponent_layout.length; i++) {
        const ac = this.activeLayout.ownComponent_layout[i]
        if (ac && !doneIds[ac.id]) {
          if (!index[ac.column]) {
            index[ac.column] = 1
          }
          components.push({ component_id: ac.component_id, column: ac.column, index: index[ac.column]++})
        }
      }
      const data = {
        id: this.activeLayout.id,
        components: JSON.stringify(components)
      }
      try {
        await axios.put(this.baseDomain + this.shopId + '/layouts/' + this.activeLayout.id + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
      }
      // console.log(components)
      // console.log('orderChanged', event)
      // console.log(this.activeLayout.ownComponent_layout)
    },
    editComponent (component) {
      if (this.customComponentEditors.includes(component.type)) {
        this.showModal('componentdetails', ModalComponentDetails, {
          props: {
            baseDomain: this.baseDomain,
            shopId: this.shopId,
            locale: this.locale,
            apiKey: this.apiKey,
            component: {
              initData: {
                componentId: component.id,
                modal: true
              }
            }
          },
          events: {
            unlinkComponent: this.unlinkComponent
          },
          handlers: {},
          width: 1200
        })
      } else {
        this.showModal('componenteditor', ComponentEditor, {
          props: {
            sourceComponent: component
          },
          events: {
            saveComponent: this.saveComponent,
            unlinkComponent: this.unlinkComponent
          },
          handlers: {},
          width: 1200
        })
      }
    },
    addComponent () {
      this.showModal('componentselector', ComponentSelector, {
        props: {},
        events: {
          selectComponent: this.selectComponent,
          addComponent: this.addComponentDialog
        },
        handlers: {},
        width: 800
      })
    },
    addComponentDialog () {
      this.showDialog({
        title: this._('New component'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'type'],
            handler: (data) => {
              const d = {
                name: data.name,
                type: data.type.value
              }
              this.saveNewComponent(d)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          },
          {
            title: this._('Type'),
            type: 'selectize',
            name: 'type',
            options: this.componentOptions
          }
        ]
      })
    },
    async saveNewComponent (data) {
      let response
      if (data.type === 'Receipt') {
        data.data = JSON.stringify({
          defaultCustomerType: "client",
          disablePayments: [],
          enableBilling: "0",
          index: "1"
        })
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/components.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.selectComponent(response.data)
      // this.editComponent(response.data, data.name)
    },
    async saveComponent (data) {
      try {
        let url = this.baseDomain + this.shopId + '/components/' + data.id + '.json?apikey=' + this.apiKey
        await axios.put(url, data)
      } catch (e) {
        console.log(e)
      }
    },
    async selectComponent (id) {
      let data = JSON.parse(this.activeLayout.data)
      let column = data.columns[this.columnIndex]
      try {
        let url = this.baseDomain + this.shopId + '/layouts/' + this.activeLayout.id + '.json?apikey=' + this.apiKey
        let data = {
          id: this.activeLayout.id,
          component_id: id,
          column: column.identifier
        }
        await axios.patch(url, data)
      } catch(e) {
        console.log(e)
      }
    },
    async unlinkComponent (id) {
      let data = JSON.parse(this.activeLayout.data)
      let column = data.columns[this.columnIndex]
      try {
        let url = this.baseDomain + this.shopId + '/layouts/' + this.activeLayout.id + '.json?apikey=' + this.apiKey
        let data = {
          id: this.activeLayout.id,
          component_id: id,
          column: column.identifier,
          action: 'unlink'
        }
        await axios.patch(url, data)
      } catch(e) {
        console.log(e)
      }
    },
    /*resizer: debounce(function () {
      const el = this.$el.closest('div')
      const elW = el.offsetWidth
      if(elW < 480) {
        el.classList.add('width-xxs', 'width-xs')
        el.classList.remove('width-sm', 'width-md', 'width-lg')
      }
      if(elW > 479 && elW < 768) {
        el.classList.add('width-xs')
        el.classList.remove('width-xxs', 'width-sm', 'width-md', 'width-lg')
      }
      if(elW > 767 && elW < 992) {
        el.classList.add('width-sm')
        el.classList.remove('width-xxs', 'width-xs', 'width-md', 'width-lg')
      }
      if(elW > 991 && elW < 1200) {
        el.classList.add('width-md')
        el.classList.remove('width-xxs', 'width-xs', 'width-sm', 'width-lg')
      }
      if(elW > 1199) {
        el.classList.add('width-lg')
        el.classList.remove('width-xxs', 'width-xs', 'width-sm', 'width-md')
      }
      this.$emit('resize', elW)
    }, 100)*/
  },
  watch: {
    components: {
      deep: true, 
      handler (newValue) {
        this.myComponents = [{ id: 'menu' }, ...newValue, { id: 'add' }]
      }
    }
  },
  created () {
    if (this.components) {
      this.myComponents = [{ id: 'menu' }, ...this.components, { id: 'add' }]
    }
  },
  mounted () {
    // The column root is the tab panel. Columns get their id from pages/[shopid]/index.vue; others
    // (the floating Receipt) get one here, before lib/components.js reads it in the root's mounted hook.
    const panel = this.$el && this.$el.parentElement
    if (panel) {
      if (!panel.id) {
        panel.id = 'column-panel-' + this.$.uid
      }
      this.panelId = panel.id
    }
    this.EventBus.$on('socketDisconnected', () => {
      this.hasDisconnection = true
    })
    this.EventBus.$on('socketConnected', () => {
      this.hasDisconnection = false
    })
    if (window.matchMedia) {
      this.tabGridMql = window.matchMedia(TAB_GRID_QUERY)
      this.tabGridWide = this.tabGridMql.matches
      this.tabGridMql.addEventListener('change', this.onTabGridMedia)
    }
    if (this.columns && this.columnIndex === this.columns.length - 1) {
      this.tsInterval = setInterval(() => {
        this.currTs = Math.floor(Date.now() / 1000)
      }, 5000)
    }
  },
  beforeUnmount () {
    if (this.tabGridMql) {
      this.tabGridMql.removeEventListener('change', this.onTabGridMedia)
    }
    if (this.tsInterval) {
      clearInterval(this.tsInterval)
    }
  }
}

</script>

<style scoped>
.navbar-menu {
  width: 45px;
}
.show-icons .navbar-menu, .show-menu .navbar-menu {
  display: none;
}
</style>